export default __webpack_public_path__ + "static/card-image-3-31007503cbac7af8a8ea279477a274e8.png";